'use client'

import { createContext, PropsWithChildren, useContext, useState } from 'react'

type GlobalSearchContext = {
  onOpenSearch: (open?: boolean | undefined, query?: string | undefined) => void
  searchOpen: boolean
  query: string
  setQuery: (query: string) => void
}

const GlobalSearchContext = createContext<GlobalSearchContext | undefined>(undefined)

export function GlobalSearchProvider({ children }: PropsWithChildren) {
  const [searchOpen, setSearchOpen] = useState(false)
  const [query, setQuery] = useState<string>('')

  return (
    <GlobalSearchContext.Provider
      value={{
        onOpenSearch: (open = true, query = '') => {
          setSearchOpen(open)
          setQuery(query)
        },
        searchOpen: searchOpen,
        query: query || '',
        setQuery: (query = '') => {
          setQuery(query)
        },
      }}
    >
      {children}
    </GlobalSearchContext.Provider>
  )
}

export const useGlobalSearch = () => {
  const context = useContext(GlobalSearchContext)

  if (!context) {
    throw new Error('useGlobalSearch must be used within a GlobalSearchProvider')
  }

  return context
}
